const initialState = {
    isLoading: true,
    details:"",
    }
    export default initialState;